import { ReactElement } from 'react';
import { Spin } from 'antd';
import { styled } from 'styled-components';
import { blockStyle } from './styles/Block';

const StyledBlock = styled.div`
  ${blockStyle}
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 0;
`;

// 汎用ローディングコンポーネント (Suspense fallback 等で利用)
const Loading = (): ReactElement => (
  <StyledBlock>
    <Spin size='large' />
  </StyledBlock>
);

export default Loading;
